// extracted by mini-css-extract-plugin
module.exports = {"box":"imqax2zLEduCiED5aUWlp","icon":"_2t9fH1_9xmlcry5MSh8Osa"};